import React, { lazy, Suspense, useEffect } from "react";
import { useLocation } from "react-router-dom";
import Hero from "../components/bookDemo/Hero";
import "./BookDemo.css";
import ClientResultsShowcase from "../components/ClientResultsShowcase";

const FeatureCards = React.lazy(() => import("../components/bookDemo/FeatureCards"));
const ProblemSolution = React.lazy(() => import("../components/bookDemo/ProblemSolution"));
const TargetAudience = React.lazy(() => import("../components/bookDemo/TargetAudience"));
const HowItWorks = React.lazy(() => import("../components/bookDemo/HowItWorks"));
const FAQAccordion = React.lazy(() => import("../components/bookDemo/FAQCards"));
const BookDemoCTA = React.lazy(() => import("../components/bookDemo/BookDemoCTA"));
const TrustPilot = React.lazy(() => import("../components/bookDemo/TrustPilot"));
const MoneyManagerFeature = React.lazy(() => import("../components/bookDemo/MoneyManagerFeature"));

const BookDemo = () => {
  const location = useLocation();

  useEffect(() => {
    if (location.hash) {
      setTimeout(() => {
        const el = document.getElementById(location.hash.replace("#", ""));
        if (el) {
          el.scrollIntoView({ behavior: "smooth", block: "start" });
        }
      }, 200); // 200ms delay for mobile rendering
    }
  }, [location]);

  return (
    <div className="book-demo-page">
      <Suspense fallback={<div className="loading-spinner">Loading...</div>}>
        <Hero />
        <ClientResultsShowcase />
        <ProblemSolution />
        <MoneyManagerFeature />
        {/* <FeatureCards /> */}
        <TargetAudience />
        <HowItWorks />
        <FAQAccordion />
        <BookDemoCTA />
        <TrustPilot />
      </Suspense>
    </div>
  );
};

export default BookDemo;
